import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  Alert,
  Autocomplete,
  Avatar,
  AvatarGroup,
  Box,
  Card,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Stack,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialTypography from "../../components/MaterialTypography";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { BASE_URL, postData } from "../Utils/Baseurl";
import axios from "axios";
import { useLoading } from "../../context/loadingcontext";
import ChatBot from "../chatbot";
import MaterialButton from "../../components/MaterialButton";
import MaterialInput from "../../components/MaterialInput";
import MaterialSelect from "../../components/MaterialSelect";

const AllProject = () => {

  const teamMembers = [
    { name: 'John Doe', avatarUrl: 'https://pluspng.com/img-png/logo-a-project-png-our-partners-1698.png' },
    { name: 'Jane Smith', avatarUrl: 'https://logos-download.com/wp-content/uploads/2018/07/Project_logo_eng.png' },
    { name: 'Bob Johnson', avatarUrl: 'https://cdn3.vectorstock.com/i/1000x1000/36/47/green-project-logo-design-template-vector-20863647.jpg' },
    { name: 'Alice Brown', avatarUrl: 'https://via.placeholder.com/150' },
  ];
  const [anchorEl, setAnchorEl] = useState(null);
  const opendialog = Boolean(anchorEl);
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [chatBotStatus, setChatBotStatus] = useState(false);
  const [suggestion, setSuggestion] = useState("");
  const [open, setOpen] = useState(false);
  const [portfolio, setPortfolio] = useState({
    programName: '',
    programCode: '',
    manager: '',
    project: [],
    programNameStatus: 'unchecked',
    programCodeStatus: 'unchecked',
    managerStatus: 'unchecked',
    projectStatus: 'unchecked',
  });
  const [projectData, setProjectData] = useState([]);
  const [projectManager, setProjectManager] = useState([]);
  const [portfolioData, setPortfolioData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editId, setEditId] = useState(0);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info',
  });


  useEffect(() => {
    fetchPortfolioData();
    fetchChatList();
    fetchProjectData();
  }, []);

  // chatbot list api
  const fetchChatList = async () => {
    setCirleLoading(true);
    try {
      const res = await postData("ai/ManagerProjectAnalysis/");
      setChatBotStatus(true);
      setSuggestion(res?.analysis || res?.message);
    } catch (error) {
      setSuggestion("");
      setChatBotStatus(false);
    } finally {
      setCirleLoading(false);
    }
  };

  /**
   * Fetches the portfolio data from the API and updates the state with the retrieved data.
   * Retrieves the authentication token from session storage and includes it in the request headers.
   * Upon successful response, sets the portfolioData state with the fetched data.
   * Logs any errors encountered during the fetch operation.
   */

  const fetchPortfolioData = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}api/program-fillter-projects-summary/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      })
      console.log(response.data.data, 'response of the portfolio');
      setPortfolioData(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Fetches a list of projects from the API and updates the state with the retrieved data.
   * Retrieves the authentication token from session storage and includes it in the request headers.
   * Upon successful response, transforms the data to match the expected format and sets the projectData state with the transformed data.
   * Logs any errors encountered during the fetch operation.
   */
  const fetchProjectData = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}api/project/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const transformedData = data.data.map(item => ({
        id: item.id,
        project_name: item.project_name,
      }));
      setProjectData(transformedData);
    } catch (error) {
      console.error(error, "error");
    }
  }

  /**
   * Fetches a list of project managers from the API and updates the state with the retrieved data.
   * Retrieves the authentication token from session storage and includes it in the request headers.
   * Upon successful response, sets the projectManager state with the fetched data.
   * Logs any errors encountered during the fetch operation.
   */


  const members = Array.isArray(teamMembers) ? teamMembers : [];
  const extraMembers = members.length > 3 ? members.length - 3 : 0;

  const handleMenuClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
  };

  /**
   * Opens the edit dialog and populates the form with the selected item's data.
   * Sets the state to open the dialog.
   * If an item is selected, updates the editId and portfolio state with the selected item's details.
   * Closes the menu after setting the states.
   */

  const handleEdit = () => {
    setOpen(true);
    if (selectedItem) {
      setEditId(selectedItem.program_id);
      setPortfolio({
        programName: selectedItem.program_name,
        programCode: selectedItem.program_code,
        manager: {
          value: selectedItem.program_manager,
          label: selectedItem.program_manager_name
        },
        project: selectedItem.projects.map(project => project.project_name),
        programNameStatus: 'success',
        programCodeStatus: 'success',
        managerStatus: 'success',
        projectStatus: 'success',
      })
    }
    handleMenuClose();
  };

  const handleView = () => {
    if (selectedItem) {
      navigate('/all-project/portfolio-details', {
        state: { data: selectedItem },
      });
    }
    handleMenuClose();
  };

  const handleDelete = async () => {
    if (selectedItem) {
      const itemId = selectedItem.program_id;
      if (setPortfolioData) {
        setPortfolioData(portfolioData.filter(item => item.id !== itemId));
      }
      try {
        const token = sessionStorage.getItem("token");
        const response = await axios.delete(`${BASE_URL}api/program/${itemId}/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      } catch (error) {
        console.error(error, "error");
      }
    }
    handleMenuClose();
    fetchPortfolioData();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setPortfolio((prevPortfolio) => {
      const updatedPortfolio = { ...prevPortfolio };
      const statusField = `${name}Status`;

      switch (name) {
        case 'programName':
          const alphabetRegex = /^[a-zA-Z ]*$/;
          if (value.trim() === '') {
            updatedPortfolio.programNameStatus = 'error';
          } else if (!alphabetRegex.test(value)) {
            updatedPortfolio.programNameStatus = 'error';
          } else {
            updatedPortfolio.programNameStatus = 'success';
          }
          updatedPortfolio.programName = value;
          break;

        case 'programCode':
          const alphanumericRegex = /^[a-zA-Z0-9]*$/;
          if (value.trim() === '') {
            updatedPortfolio.programCodeStatus = 'error';
          } else if (!alphanumericRegex.test(value)) {
            updatedPortfolio.programCodeStatus = 'error';
          } else {
            updatedPortfolio.programCodeStatus = 'success';
          }
          updatedPortfolio.programCode = value;
          break;

        case 'programManager':
          updatedPortfolio.managerStatus = value ? 'success' : 'error';
          updatedPortfolio.manager = value;
          break;

        case 'projects':
          updatedPortfolio.projectStatus = value ? 'success' : 'error';
          updatedPortfolio.project = value;
          break;

        default:
          break;
      }

      return updatedPortfolio;
    });
  };

  const handleManagerchange = (selectedOption) => {
    setPortfolio((prevPortfolio) => ({
      ...prevPortfolio,
      manager: selectedOption,
      managerStatus: selectedOption ? 'success' : 'error',
    }));
  };

  const handleProjectChange = (event, newValue) => {
    setPortfolio({
      ...portfolio,
      project: newValue,
      projectStatus: newValue.length > 0 ? 'success' : 'error',
    })
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  /**
   * Handles submission of the portfolio form.
   * Constructs a FormData object from the portfolio state and sends a POST/PUT request to the API.
   * If the request is successful, logs a success message, sets a success snackbar, and resets the form.
   * If the request fails, logs an error message, sets an error snackbar, and remains on the current page.
   * If the request is updating an existing portfolio, sets editId to 0 and resets the form.
   */
  const handlePortfolioSubmit = async () => {
    const data = {
      program_name: portfolio.programName,
      program_code: portfolio.programCode,
      program_manager: portfolio.manager.value,
      program_project: portfolio.project.map(p => ({
        project_id: String(p.id)
      })),
    };
    try {
      const token = sessionStorage.getItem("token");
      if (editId === 0) {
        const response = await axios.post(`${BASE_URL}api/program/`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        setSnackbar({
          open: true,
          message: 'Portfolio created successfully!',
          severity: 'success',
        });
      } else {
        const response = await axios.put(`${BASE_URL}api/program/${editId}/`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        setSnackbar({
          open: true,
          message: 'Portfolio updated successfully!',
          severity: 'success',
        });
        setEditId(0);
        setPortfolio({
          programName: '',
          programCode: '',
          manager: '',
          project: [],
          programNameStatus: 'unchecked',
          programCodeStatus: 'unchecked',
          managerStatus: 'unchecked',
          projectStatus: 'unchecked',
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: `Failed to ${editId === 0 ? 'create' : 'update'} project`,
        severity: 'error',
      });
    } finally {
      setOpen(false);
    }
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="bold" color="dark">
            Program
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view all the programs here.
          </MaterialTypography>
        </Stack>
        <Stack>
          <MaterialButton
            variant="contained"
            color="dark"
            onClick={handleOpen}
          >
            Add program
          </MaterialButton>
        </Stack>
      </Stack>
      {/* {chatBotStatus && (
        <div className="chatbox-container">
          <ChatBot suggestionText={suggestion} style={{ marginTop: "-100px" , marginRight:'180px'}} />
        </div>
      )} */}
      <Grid container direction='row' spacing={2} p={2}>
        {portfolioData.map((item, index) => (
          <Grid sx={{ xs: 6, sm: 4, md: 3 }} key={item.id}>
            <Card sx={{ padding: 2, width: '180px' }}>
              <IconButton
                sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                }}
                aria-label="more options"
                onClick={(event) => handleMenuClick(event, item)}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={opendialog}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <MenuItem onClick={handleEdit}>Edit</MenuItem>
                <MenuItem onClick={handleView}>View</MenuItem>
                <MenuItem onClick={handleDelete}>Delete</MenuItem>
              </Menu>
              <Grid container direction='column' spacing={1} >
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                  <MaterialTypography variant="h6" color='dark' fontWeight="bold" sx={{ fontSize: '14px' }}>{item.program_name}</MaterialTypography>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12 }} sx={{ mt: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', padding: 0 }}>
                    <AvatarGroup>
                      {item.projects.slice(0, 3).map((member, index) => (
                        <Avatar
                          key={index}
                          alt={member.project_name || `Team Member ${index + 1}`}
                          src={member.project_logo || 'https://via.placeholder.com/150'}
                          sx={{ width: 30, height: 30, border: '2px solid white' }}
                        />
                      ))}
                      {/* {extraMembers > 0 && (
                        <Badge
                          badgeContent={`+${extraMembers}`}
                          sx={{
                            '& .MuiBadge-badge': {
                              backgroundColor: '#5c6cbf',
                              color: 'white',
                              fontSize: '12px',
                              fontWeight: 'bold',
                              width: 28,
                              height: 28,
                              borderRadius: '50%',
                              border: '2px solid white',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            },
                          }}
                        />
                      )} */}
                    </AvatarGroup>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                  <MaterialTypography variant='caption' color='text'>{item.program_manager_name}</MaterialTypography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="portfolio-dialog-title"
        sx={{ '& .MuiDialog-paper': { width: '600px', maxWidth: '90%', height: 'auto' } }}
      >
        <DialogTitle id="portfolio-dialog-title">{editId === 0 ? 'Add Portfolio' : 'Edit Portfolio'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color='text'>Portfolio Name<span style={{ color: 'red' }}>*</span></MaterialTypography>
                <MaterialInput
                  label="Program Name"
                  name='programName'
                  value={portfolio.programName}
                  onChange={handleInputChange}
                  error={portfolio.programNameStatus === 'error'}
                  success={portfolio.programNameStatus === 'success'}
                />
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Stack direction='column' spacing={1}>
                <MaterialTypography variant="caption" color='text'>Portfolio Manager<span style={{ color: 'red' }}>*</span></MaterialTypography>
                <MaterialSelect
                  label="Program Manager"
                  name='programManager'
                  value={portfolio.manager}
                  options={projectManager.map((manager) => ({ label: manager.employee_name, value: manager.id }))}
                  onChange={handleManagerchange}
                  error={portfolio.managerStatus === 'error'}
                  success={portfolio.managerStatus === 'success'}
                />
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color='text'>Portfolio Code<span style={{ color: 'red' }}>*</span></MaterialTypography>
                <MaterialInput
                  label="Program Code"
                  name='programCode'
                  value={portfolio.programCode}
                  onChange={handleInputChange}
                  error={portfolio.programCodeStatus === 'error'}
                  success={portfolio.programCodeStatus === 'success'}
                />
              </Stack>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <Stack direction='column' spacing={1}>
                <MaterialTypography variant="caption" color='text'>Projects<span style={{ color: 'red' }}>*</span></MaterialTypography>
                <Autocomplete
                  multiple
                  id="tags-outlined"
                  options={projectData || []}
                  getOptionLabel={(option) => `${option?.project_name || ''} `}
                  value={portfolio.project}
                  onChange={handleProjectChange}
                  filterSelectedOptions
                  renderTags={(selected, getTagProps) =>
                    selected.map((option, index) => (
                      <Chip
                        key={option?.id || index}
                        label={`${option?.project_name || ''}`}
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Add project here...." />
                  )}
                />
              </Stack>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MaterialButton variant='text' color='error' onClick={handleClose}>Cancel</MaterialButton>
          <MaterialButton variant='contained' color='dark' onClick={handlePortfolioSubmit}>{editId === 0 ? 'Save' : 'Update'}</MaterialButton>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

    </DashboardLayout>
  );
};

export default AllProject;
